export function isoDurationToDays( duration ) {
    if ( typeof duration === 'number' ) {
        return duration;
    } else if ( typeof duration === 'string' ) {
        const regex = /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?/;
        const matches = new RegExp( regex ).exec( duration );
        if ( matches ) {
            const years = +matches[ 1 ] || 0;
            const months = +matches[ 2 ] || 0;
            const days = +matches[ 3 ] || 0;

            return years * 365 + months * 30 + days;
        } else {
            console.log(`Error, duration ${duration} doesn't match pattern ${regex}`);
            return 0;
        }
    }
}
